import { Component, OnInit, Output, EventEmitter, Injectable, Inject,ViewChild,Input, ElementRef } from '@angular/core';
import { HttpEventType, HttpClient} from '@angular/common/http';
import { HttpService } from '../../services/http.service';
@Component({
    selector: 'upload-files',
    templateUrl: './upload-files.html',
    styleUrls: ['./upload-files.css']
})
export class UploadFilesComponent implements OnInit {
    public progress: number;
    public message: string;
    @Output() public onUploadFinished = new EventEmitter();
    @Input() public urlImport: string;
    @Input() public paramPost: string;
    @ViewChild("file") fileControl: ElementRef; 
   
    constructor(private http: HttpService,@Inject('BASE_URL') public baseUrl: string) { }

    ngOnInit() {
    }

    public uploadFile = (files) => {
        if (files.length === 0) {
            return;
        }

        let fileToUpload = <File>files[0];
        const formData = new FormData();
        formData.append('file', fileToUpload, fileToUpload.name);
        formData.append('paramPost', this.paramPost);
        this.http.post(this.urlImport, formData, res => {
            this.fileControl.nativeElement.value = "";//reset control upload
            if (res.ID = 1) {
                alert("upload successfully");
            } else {
                alert("upload fail");
            }
            
            this.onUploadFinished.emit(res);
        });
    }
}
